import { useContext } from "react";
import { AppContext } from "../App";
import { FiPackage, FiShield, FiShoppingCart } from "react-icons/fi";

export default function PharmacyServices() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiPackage />,
      title: "Full-Service Clinical Pharmacy",
      desc: "Operating directly under a qualified Pharmacist providing verification, therapeutic screening, accurate dispensing, and explicit drug counseling protocols."
    },
    {
      icon: <FiShoppingCart />,
      title: "One-Stop Pharmaceutical Supply",
      desc: "A reliable point of access for authentic, verified pharmaceutical formulations, chronic medication refills, and personal medical care essentials."
    },
    {
      icon: <FiShield />,
      title: "Biomedical Equipment Access",
      desc: "In-facility distribution of verified biomedical machinery, supportive therapy equipment, and modern diagnostic monitoring devices for home usage."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <span className="pillar-tag">Pillar IV</span>
        <h2 className="pillar-title">Pharmacy Services</h2>
        <p className="pillar-subtitle">Fully integrated dispensary models ensuring supply chain authenticity and clinical safety controls.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext?.navTo?.({ item: "services", extra: "pharmacy-details" })}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}